import { isLiveMallClub } from '@/constants/systemType'
import classnames from 'classnames/bind'
import { useField, useFormikContext } from 'formik'
import { isEmpty } from 'lodash-es'
import PropTypes from 'prop-types'

// Variables / Functions
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  helpText: PropTypes.string,
}

export const defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  rows: 3,
}

function TextareaField(props) {
  const { className, name, onChange: onChangeProps, onBlur: onBlurProps, placeholder, disabled, rows, helpText, ...restProps } = props
  const [field, meta] = useField(props)
  const { setFieldValue, handleBlur } = useFormikContext()

  const hasError = meta.touched && !isEmpty(meta.error)

  const onChange = (event) => {
    const value = event.target.value
    setFieldValue(field.name, value)
    onChangeProps(value)
  }

  const onBlur = (event) => {
    onBlurProps(event)
    handleBlur(event)
  }

  return (
    <div
      className={cx(
        'textarea-field-wrapper',
        {
          'common-component-textarea': isLiveMallClub,
        },
        className,
      )}
    >
      <textarea
        className={cx('textarea-field-wrapper-textarea', { 'has-error': hasError })}
        onChange={onChange}
        onBlur={onBlur}
        value={field.value || ''}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        aria-describedby='comment-help'
        {...restProps}
      />
      {helpText && (
        <p className={cx('textarea-field-wrapper-help-text')} id='comment-help'>
          {helpText}
        </p>
      )}
    </div>
  )
}

TextareaField.propTypes = propTypes
TextareaField.defaultProps = defaultProps

export default TextareaField
